import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend'; // primary use cache
import HttpApi from 'i18next-http-backend'; // fallback http load

// the translations
// (tip move them in a JSON file and import them)
// const resources = {
// 	en: {
// 		translation: {
// 			login: 'Login',
// 		},
// 	},
// 	zh: {
// 		translation: {
// 			login: '登入',
// 		},
// 	},
// };

i18n.use(initReactI18next)
	.use(LanguageDetector)
	.use(Backend)
	.init({
		// resources,
		fallbackLng: 'en',
		backend: {
			backends: [LocalStorageBackend, HttpApi],
			backendOptions: [
				{
					expirationTime: 60 * 60 * 1000,
				},
				{
					loadPath: '/locales/{{lng}}/{{ns}}.json',
				},
			],
		},
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
